import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';


function I18nMessage(props) {

    const {formatMessage} = useIntl();
    const enhancedValues = {
        br: <br/>,
        em: chunks => <em>{chunks}</em>,
        span: chunks => <span>{chunks}</span>,
        strong: chunks => <strong>{chunks}</strong>,
        ...props.values
    };

    return formatMessage(props, enhancedValues);
}


I18nMessage.propTypes = {
    id: PropTypes.string.isRequired
};


export default I18nMessage;
